import {UserGroupComponent} from './user-group/user-group.component';
import {Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Params, Router, RoutesRecognized } from '@angular/router';
import { AuthClient } from './auth/auth.client';
import {Subscription} from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private queryParams: { [key: string]: any };
  private subscription: Subscription;

  constructor(private _translateService: TranslateService,
          private route: ActivatedRoute,
          private _authClient: AuthClient,
          private _router: Router,) {
      this.initTranslate();

      this._router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        if(!data.state.root.firstChild.data.ignoreAuth) {
          this.route.queryParamMap.pipe(take(1)).subscribe((params: Params) => {
            const _queryParams = this.getQueryParams();
            this.queryParams = _queryParams ? _queryParams : params;

            // Init AuthClient and try to Login
            this._authClient.init(this.queryParams);
          });
        }
        else {
          this._authClient.GetAuthenticationType();
        }
      }
    });
  }

  ngOnInit() {
    this.initTranslate();
    this._authClient.GetAntiForgeryToken();
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getQueryParams(): any {
    let result;
    const queryParams = window.location.href.split('?');
    if (queryParams.length > 1) {
      const keys = queryParams[1].split('&');
      const obj = {};
      keys.forEach((k) => {
        const value = k.split('=');
        obj[value[0]] = value[1];
      });
      result = obj;
    }
    return result;
  }

  private initTranslate(): void {
    const language = this._translateService.getBrowserLang();
    this._translateService.addLangs(['en', 'es']);
    this._translateService.setDefaultLang('en');
    switch (language) {
      case 'es':
        this._translateService.use('es');
        break;
      default: this._translateService.use('en');
        break;
    }
  }
}
